import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
    selector: 'formly-field-addrow',
    template: `
@if (props.icon || props.label) {
  <button mat-fab extended type='button' [formlyAttributes]="field" color='primary'>
    @if ( props.icon ) {
    <mat-icon >{{props.icon}}</mat-icon>
    }
    {{props.label}}
  </button>
}
@if ( !!props.description ) {
  <mat-hint >{{props.description}}</mat-hint>
}`,
    styleUrls: ['../../../assets/global-settings.scss'],
    standalone: false
})

export class AddRowComponent extends FieldType { }